export default "__VITE_ASSET__Cn8i6hfI__"